<template>
  <div class="authlist-edit-container">
    <el-form class="edit-form" :model="formData" :rules="formRules" ref="form" label-position="top">
      <el-form-item label="设备编码" prop="deviceCode">
        <el-input v-if="editType === 'add'" v-model="formData.deviceCode" placeholder="请输入"></el-input>
        <span v-else>{{ formData.deviceCode }}</span>
      </el-form-item>
      <!-- <el-form-item v-if="deviceType == '104'" label="设备型号" prop="deviceModel">
        <el-select class="w-p-100" v-model="formData.deviceModel" placeholder="请选择">
          <el-option
            v-for="item in bellDeviceTypeList"
            :key="item.name"
            :label="item.value"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="出货区域" prop="fullArea">
        <AreaCascader v-if="show" v-model="formData.fullArea" :end-level="2" />
      </el-form-item>
      <!-- <el-form-item label="项目" prop="projectCode">
        <el-select class="w-p-100" v-model="formData.projectCode" placeholder="请选择">
          <el-option
            v-for="item in projectList"
            :key="item.name"
            :label="item.value"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <div class="bottom-btn">
        <el-button class="submit-btn" @click="handleConfirm">确定</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AreaCascader from '@/components/common/areaCascader'

export default {
  components: { AreaCascader },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editType: {
      type: String,
      default: 'add',
    },
    detailData: {
      type: Object,
      default: () => ({}),
    },
    projectList: {
      type: Array,
      default: () => ({}),
    },
    deviceType: {
      type: [String, Number]
    },
  },
  data() {
    return {
      bellDeviceTypeList: [],
      
      formData: {
        id: '',
        deviceCode: '',
        // deviceModel: '',
        fullArea: '',
        // projectCode: '',
      },
      formRules: {
        deviceCode: [
          { required: true, message: '设备编码不能为空', trigger: 'blur' },
          { validator: this.emptyValidator, trigger: 'blur' }
        ],
        // deviceModel: [
        //   { required: true, message: '设备型号不能为空', trigger: 'change' },
        // ],
        // fullArea: [{ required: true, message: '出货区域不能为空', trigger: 'change' }],
        // projectCode: [{ required: true, message: '项目不能为空', trigger: 'change' }],
      },
    }
  },
  created() {
    if (this.editType === 'edit') {
      this.buildEditForm()
    }
    // this.getDictData()
  },
  watch: {
    show(val) {
      if (val) {
        if (this.editType === 'edit') {
          this.buildEditForm()
        }
      } else {
        for (let key in this.formData) {
          this.formData[key] = ''
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  },
  methods: {
    ...mapActions(['fetchData']),
    // 空字符串校验
    emptyValidator(rule, value, callback) {
      if (value.trim() == '') {
        callback(new Error('必填项不能为空格'))
      } else {
        callback()
      }
    },
    // 获取字典数据
    // getDictData() {
    //   let url = 'RESOURCE.GET_MULTI_LIST'
    //   this.fetchData({
    //     url,
    //     method: 'get',
    //     params: {
    //       type: 'doorbell_model',
    //       start: 0,
    //       size: 1000,
    //       toExcel: false,
    //     },
    //   }).then((res) => {
    //     this.bellDeviceTypeList = [...res.data]
    //   })
    // },
    // 构建编辑表单
    buildEditForm() {
      for (let key in this.formData) {
        this.formData[key] = this.detailData[key]
      }
      this.formData.fullArea = [this.detailData.provinceCode, this.detailData.cityCode, this.detailData.regionCode]
    },
    // 处理表单确认
    handleConfirm() {
      this.$refs.form.validate((v) => {
        if (v) {
          let params = { ...this.formData }
          // params.provinceCode = this.formData.fullArea[0]
          // params.cityCode = this.formData.fullArea[1]
          // params.regionCode = this.formData.fullArea[2]
          params.deviceType = this.deviceType
          if (this.formData.fullArea && this.formData.fullArea.length) {
            let araeCode = [...this.formData.fullArea]
            params.shippingArea = araeCode.pop()
          }

          delete params.fullArea
          if (this.editType === 'add') {
            delete params.id
          }
          // if (this.deviceType == '103') {
          //   delete params.deviceModel
          // }
          this.handleSaveOrUpdate(params)
        } else {
          this.$message.warning('请完善信息！')
        }
      })
    },
    // 处理新增或编辑
    handleSaveOrUpdate(params) {
      let url = 'DEVICE.POST_ADD_OR_UPDATE_AUTH'
      this.fetchData({ url, method: 'post', params, flag: true, headers: { "Content-Type": "application/json" } }).then(res => {
        if (res.code == 200) {
          let text = this.editType === 'add' ? '新增成功！' : '编辑成功！'
          this.$message.success(text)
          this.$emit('success')
        } else {
          this.$message.error(res.msg || (this.editType === 'add' ? '新增失败！' : '编辑失败！'))
        }
      })
    },
    // 处理取消操作
    handleCancel() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.authlist-edit-container {
  :deep(.el-cascader) {
    width: 100%;
  }
}
.bottom-btn {
  padding-top: 10px;
  text-align: center;
  width: 100%;
}
</style>